const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True for a canonical GUID in any letter case, e.g. `f2f99afc-1441-498d-bde4-a464171c8330`. */
export const isGuid = (text: string): boolean => GUID.test(text);

/** The first group of a GUID, shown in grids in place of the whole value: `f2f99afc`. */
export const guidHead = (guid: string): string => guid.slice(0, 8);
